import { hashData } from '@/utils/index'

export const pushToDataLayer = async (event, { application, dog, user }) => {
  if (typeof window === 'undefined') return

  const dataLayer = window.dataLayer || []

  if (user && dog && application) {
    dataLayer.push({
      event,
      data: {
        dogId: dog?.id,
        dogName: dog?.name,
        price: dog?.price / 100,
        breederId: dog?.breederId,
        // @TODO: Apply discount
        fees: dog?.salePrice?.fapFee / 100,
        user: {
          sha256_email_address: await hashData(user.email.trim()),
          sha256_phone_number: await hashData(application?.phoneNumber.trim()),
          address: {
            sha256_first_name: await hashData(user.firstName),
            sha256_last_name: await hashData(user.lastName),
            street: application?.address,
            city: application?.city,
            postal_code: application?.zipcode,
            region: application?.state?.value,
            country: application?.country?.value
          }
        }
      }
    })
  }
}
